<div class="container-fluid cabecalho p-d-none p-d-xl-flex fundo-branco">
    <div class="container">
        <div class="p-grid p-mt-2 p-ai-center">
            <div class="p-col-12 p-lg-3 p-p-2 p-d-flex p-ai-end p-jc-start">
                <div class="p-grid p-p-0 p-text-center">
                    <a class="p-col font-size-1 text-color-black text-decoration-none" href="{{pathFormularioSIC.caminho}}"
                        pTooltip="Acessar página do SIC/Ouvidoria" tooltipPosition="bottom" target="_blank" style="line-height: normal;">
                        <fa-icon [icon]="faEnvelopeOpen" class="fa-2x text-color-blue p-d-block"></fa-icon>
                        SIC/ <br> Ouvidoria
                    </a>
                    <!-- <a class="p-col font-size-1 text-color-black text-decoration-none" routerLink="{{pathCanaisAtendimento.caminho + '/' + pathCentralDeAtendimento.caminho}}"
                        pTooltip="Acessar página da central de atendimento" tooltipPosition="bottom" style="line-height: normal;">
                        <fa-icon [icon]="faHeadset" class="fa-2x text-color-blue p-d-block"></fa-icon>
                        Central de<br>Atendimento
                    </a> -->
                    <a class="p-col font-size-1 text-color-black text-decoration-none" routerLink="{{pathCanaisAtendimento.caminho + '/' + pathBalcao.caminho}}"
                        pTooltip="Acessar página do balcão virtual" tooltipPosition="bottom" style="line-height: normal;">
                        <fa-icon [icon]="faChalkboardTeacher" class="fa-2x text-color-blue p-d-block"></fa-icon>
                        Balcão <br>Virtual
                    </a>
                    <a class="p-col font-size-1 text-color-black text-decoration-none" href="https://acessofacil.jfrn.jus.br/peticao-cadastro"
                       pTooltip="Acessar o programa Acesso Fácil" tooltipPosition="bottom" style="line-height: normal; display: grid; justify-items: center;">
                        <img src="./assets/images/acessofacil-icon.svg" class="text-color-black p-d-block" style="width: 27px">
                            Acesso <br>Fácil
                    </a>
                </div>
            </div>

            <div class="p-col-12 p-lg-1 p-d-flex p-ai-center p-jc-end">
              <div class="selo-container" pTooltip="Selo TOP" tooltipPosition="bottom">
                <a href="https://top.nic.br" target="_blank">
                  <img class="selo-img" src="./assets/images/selo-website-test.png" alt="Selo TOP - Site">
                </a>
                <a href="https://top.nic.br" target="_blank">
                  <img class="selo-img" src="./assets/images/selo-email-test.png" alt="Selo TOP - Email">
                </a>
              </div>
            </div>

            <div class="p-col-12 p-lg-5 p-p-2 p-d-flex p-ai-center p-jc-start">
                <div class="p-grid p-text-center">
                    <a routerLink = "/"  class="p-col-12 p-xl-6 p-p-2 p-text-center">
                        <img height="60px" src="/assets/images/logo-jfrn.svg" alt="Justiça Federal do Rio Grande do Norte"
                            pTooltip="Página da Justiça Federal no Rio Grande do Norte" tooltipPosition="bottom">
                    </a>
                </div>

                <div class="p-grid p-text-center" *ngIf="possuiImagem">
                    <a class="p-col-12 p-xl-6 p-p-4 p-text-center">
                        <img height="50px" src={{linkImagem}}  tooltipPosition="bottom">
                    </a>
                </div>
            </div>

            <div class="p-col-12 p-lg-3 p-p-2 p-d-flex p-ai-center p-jc-end">
                <div class="p-col-12 p-grid p-fluid p-text-center" style="width: 215px">
                    <form [formGroup]="formularioDeBusca">
                        <input class="w-100" pInputText type="text" (keydown)="onKeydownEvent($event)" accesskey="b"
                            placeholder="Pesquisar por..." formControlName="textoPesquisa">
                        <button class="icone-busca p-d-flex" (click)="redirecionarBusca()"
                            alt="Buscar" aria-label="Buscar" pTooltip="Realizar busca" tooltipPosition="bottom">
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <div class="p-col-12 p-text-right p-m-0 p-p-0" style="margin-top: -15px !important">
            <a href="{{pathFormularioSIC.caminho}}" style="text-decoration:none;  font-size: 0.75rem;" target="_blank"
                pTooltip="Acessar o Serviço de Informação ao Cidadão/Ouvidoria" tooltipPosition="bottom">SIC - Serviço de Informação ao Cidadão/Ouvidoria</a>
        </div>
    </div>
</div>

<div class="p-d-none p-d-xl-flex" [ngClass]="{'menu-relative' : true, 'menu-height' : isSticky}"></div>

<div class="container-fluid p-d-none p-d-xl-flex fundo-branco" [ngClass]="{'menu-relative' : true, 'sticky' : isSticky}">
    <div class="container menu-sticky">
        <div class="p-grid p-ai-center p-py-3 p-m-0">
            <div class="p-col-fixed" style="width: 130px; padding: 0;" [ngClass]="{'p-col-fixed' : false, 'p-d-none' : !isSticky}">
                <a routerLink="/">
                    <img class="logo" src="/assets/img/logo-jfrn-pequena.svg" alt="Logotipo da Justiça Federal do Rio Grande do Norte" height="40px">
                </a>
            </div>
            <div class="p-col p-px-0">
                <ul class="nav">
                    <li><a routerLink="/" accesskey="1">INÍCIO</a></li>
                    <li><a routerLink="/institucional" accesskey="2">INSTITUCIONAL</a></li>
                    <li><a routerLink="/administracao" accesskey="3">ADMINISTRAÇÃO</a></li>
                    <li><a routerLink="/processos-fisicos" accesskey="4">PROCESSOS</a></li>
                    <li><a routerLink="/juizados-especiais" accesskey="5">JUIZADOS ESPECIAIS</a></li>
                    <li><a [href]=rotaTurmaRecursal accesskey="6">TURMA RECURSAL</a></li>
                    <li><a routerLink="/varas-federais" accesskey="7">VARAS FEDERAIS</a></li>
                    <li><a routerLink="/transparencia" accesskey="8">TRANSPARÊNCIA</a></li>
                    <li><a routerLink="/institucional/lgpd" accesskey="9">LGPD</a></li>
                    <li><a routerLink="/imprensa" accesskey="10">IMPRENSA</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
